/* eslint-disable no-unused-vars */
import React from "react";
import { Field, ErrorMessage, useField } from "formik";
import swal from "sweetalert";
import { getBase64 } from "../../pages/Registration";

const ImageInput = ({ label, name, ...rest }) => {
  const [field, meta, helpers] = useField({ name });

  const handleChange = async (event) => {
    const file = event.target.files[0];
    const sizeLimit = 50 * 1024 * 1024; // 50MB

    if (file) {
      const fileType = file.type;

      if (file.size > sizeLimit) {
        swal("Oops", "Max File Size is 50 MB!", "error", {
          button: "Try Again!",
        });

        return;
      }

      // Check if the selected file is of type jpg or png
      if (fileType === "image/jpeg" || fileType === "image/png") {
        const base64String = await getBase64(file);
        helpers.setValue(base64String);
      } else {
        helpers.setValue("");

        swal("Oops", "Please select a valid JPG or PNG file.", "error", {
          button: "Try Again!",
        });
      }
    }
  };

  return (
    <div className="mb-3">
      <label htmlFor={name} className="form-label">
        {label}
      </label>
      <input
        type="file"
        name={name}
        id={name}
        onChange={handleChange}
        {...rest}
        className={`form-control ${
          meta.touched && meta.error ? "is-invalid" : ""
        }`}
      />
      <div className="invalid-feedback">
        <ErrorMessage name={name} />
      </div>
    </div>
  );
};

export default ImageInput;
